import React, { useState, useEffect, useRef } from "react";

const ToggleVisibility = ({ children, toggle }) => {
  let animationTime = 300;
  let timeout;
  const [addToDOM, setAddToDOM] = useState(false);
  const wrapper = useRef();

  useEffect(() => {
    if (toggle && !wrapper.current) {
      setAddToDOM(true);
    } else {
      timeout = setTimeout(() => {
        setAddToDOM(false);
      }, animationTime);
    }
  }, [toggle]);

  useEffect(() => {
    if (wrapper.current) {
      if (toggle) {
        timeout = setTimeout(() => {
          wrapper.current.style.opacity = "1";
        }, 100);
      } else {
        wrapper.current.style.opacity = "0";
      }
    }
  });

  if (addToDOM)
    return (
      <div
        data-test="ToggleVisibility"
        style={{ transition: `opacity ${animationTime}ms ease-in-out`, opacity: "0" }}
        ref={wrapper}
      >
        {children}
      </div>
    );
  else return null;
};

export default ToggleVisibility;
